import { mq, spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { HorizontalAlignment } from '@thg-commerce/enterprise-core'
import { Grid } from '@thg-commerce/gravity-system'
import { Button } from '@thg-commerce/gravity-elements'

export const Title = styled.h1<{
  horizontalAlignment?: HorizontalAlignment
}>`
  ${Text('large1', 'alternate')};
  text-align: ${(props) => props.horizontalAlignment || 'left'};
  margin-bottom: ${spacing(2)};
`

export const Subtitle = styled.p<{
  extraPadding?: boolean
  horizontalAlignment?: HorizontalAlignment
}>`
  ${Text('bodyText', 'default')};
  text-align: ${(props) => props.horizontalAlignment || 'left'};
  margin-bottom: ${(props) => (props.extraPadding ? spacing(3) : spacing(1))};
`

export const DisclaimerText = styled.p`
  ${Text('small', 'default')};
`

export const SubmitButton = styled(Button)`
  margin-top: ${spacing(3)};
  margin-bottom: ${spacing(4)};
`

export const StyledNameFormItemWrapper = styled.div`
  margin-bottom: ${spacing(4)};
`

export const StyledGrid = styled(Grid)`
  padding: ${spacing(2)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(4)};
  }
`
